/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */

import tabPageMinix from '../../tabPageMinix';

export default {
    name: 'sgatajtj',
    mixins: [tabPageMinix],
    data() {
        return {
            // 全国海事法院审判案件
            tableSgatajtj: []
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.selectGattj(this.$parent.searchData);
        },

        selectGattj(searchData) {
            const _this = this;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.szsjtj.selectSjtjSwgatajForGAT,
                params: searchData
            })
                .then((res) => {
                    _this.tableSgatajtj = [{
                        title: '香港',
                        key: '344',
                        name: '香港',
                        xs: res.data['中国香港'] ? res.data['中国香港'].xsajs : 0,
                        yj: res.data['中国香港'] ? res.data['中国香港'].yjajs : 0
                    }, {
                        title: '澳门',
                        key: '446',
                        name: '澳门',
                        xs: res.data['中国澳门'] ? res.data['中国澳门'].xsajs : 0,
                        yj: res.data['中国澳门'] ? res.data['中国澳门'].yjajs : 0
                    }, {
                        title: '台湾',
                        key: '158',
                        name: '台湾',
                        xs: res.data['中国台湾'] ? res.data['中国台湾'].xsajs : 0,
                        yj: res.data['中国台湾'] ? res.data['中国台湾'].yjajs : 0
                    }];
                });
        }
    }
};

